import type React from "react";
import { Box } from "@mui/material";
import { type SxProps } from "@mui/system";

export interface FormGroupContainerProps {
	readonly children: React.ReactNode;
	readonly legend: string;
	readonly sx: SxProps;
}

export const FormGroupContainer: React.FC<FormGroupContainerProps> = ({ children, legend, sx }) => {
	return (
		<Box
			border={1}
			borderRadius={1}
			padding={2}
			sx={{
				borderColor: (theme) => theme.palette.divider,
				"& legend": {
					px: 0.5,
					color: (theme) => theme.palette.text.secondary,
				},
				...sx,
			}}
			component="fieldset"
		>
			<legend>{legend}</legend>
			{children}
		</Box>
	);
};
